import FillBlanks from "../../components/LKG/English/Articles/FillBlanks";
import TrueFalse from "../../components/LKG/English/Articles/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/lkg/english-language/articles/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/lkg/english-language/articles/true-false", title: "True & False", component: TrueFalse },
];

export default topics;